import React, { useState ,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



function Enquiry() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    project: "",
    comments: "",
    contactPreference: "WhatsApp",

  });

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};


    const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const params = new URLSearchParams();
    for (let key in formData) {
      params.append(key, formData[key]);
    }

    const response = await axios.post(
      "https://aivio.c-metric.net:8001/enquiry",
      params,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "api-key": process.env.REACT_APP_API_KEY,
        },
      }
    );

    toast.success(response.data.message || "Submitted successfully!");
    setFormData({
      name: "",
      email: "",
      mobile: "",
      project: "",
      comments: "",
      contactPreference: "",
    }); // Optional: Reset form
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Something went wrong. Please try again."
    );
  }
};


  return (
    <div className="form-wrapper">
      <div className="video-bg">
        <video autoPlay muted loop playsInline>
          <source
            src="https://cdn.pixabay.com/video/2021/10/12/91744-636709154_large.mp4"
            type="video/mp4"
          />
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="overlay" />
      <div className="form-container">
        <div className="form-card">
          <div className="form-title">Enquiry Form</div>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Full Name *
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Your Name"
                required
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email Address *
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                id="email"
                placeholder="you@example.com"
                required
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="mobile" className="form-label">
                Phone Number *
              </label>
              <input
                type="tel"
                className="form-control"
                id="mobile"
                name="mobile"
                placeholder="98765 43210"
                required
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="project" className="form-label">
                Interested Property
              </label>
              <select
                className="form-select"
                id="project"
                name="project"
                required
                onChange={handleChange}
                defaultValue=""

              >
                <option value="" disabled>
                  Select a property
                </option>
                <option>Luxury Villa – Ocean Heights</option>
                <option>3BHK Apartment – Urban Greens</option>
                <option>Commercial Office – BizHub Tower</option>
              </select>
            </div>
          <div className="mb-3">
  <label className="form-label">Preferred Contact Method *</label>
  <div className="d-flex gap-3">
    <div className="form-check d-flex align-items-center">
      <input
        className="form-check-input"
        type="radio"
        name="contactPreference"
        id="contact-call"
        value="Call"
        checked={formData.contactPreference === "Call"}
        onChange={handleChange}
        required
      />
      <label className="form-check-label ms-2 mb-0" htmlFor="contact-call">
        Get a Call
      </label>
    </div>
    <div className="form-check d-flex align-items-center">
      <input
        className="form-check-input"
        type="radio"
        name="contactPreference"
        id="contact-whatsapp"
        value="WhatsApp"
        checked={formData.contactPreference === "WhatsApp"}
        onChange={handleChange}
      />
      <label className="form-check-label ms-2 mb-0" htmlFor="contact-whatsapp">
        WhatsApp Message
      </label>
    </div>
  </div>
</div>


            <div className="mb-3">
              <label htmlFor="comments" className="form-label">
                Message / Requirements
              </label>
              <textarea
                className="form-control"
                id="comments"
                name="comments"
                rows="4"
                placeholder="Let us know your needs..."
                onChange={handleChange}
              ></textarea>
            </div>

            <button type="submit" className="btn btn-primary w-100">
              Submit
            </button>
          </form>
        </div>
      </div>
      <div id="orchestrate-chat-root"></div>

          <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default Enquiry;
